import type { MessageDescriptor } from 'react-intl';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { BodyM } from 'atoms/typography';

type Props = {
  name: MessageDescriptor;
  selected?: boolean | number;
};

const Count = styled.span`
  font-weight: 400;
  color: var(--c-nd-600);
`;

export const FilterTitle = (props: Props) => {
  const { name, selected } = props;
  const { formatMessage } = useIntl();

  if (selected) {
    return (
      <BodyM bold>
        <span>{formatMessage(name)}&nbsp;</span>
        <Count>({typeof selected === 'boolean' ? 1 : selected})</Count>
      </BodyM>
    );
  }

  return <BodyM bold>{formatMessage(name)}</BodyM>;
};
